import { expVal } from '@atlassian/jira-feature-experiments';

const JiraAiAgentTeamSessionsTimestampRelayProvider = {
	get(): boolean {
		return expVal('jira_ai_agent_team_sessions_timestamp', 'isEnabled', false);
	},
};

export default JiraAiAgentTeamSessionsTimestampRelayProvider;
